// Complete.tsx
import React, { useMemo } from 'react';
import styles from './Complete.module.scss';
import global from '../../../styles/index.module.scss';
import { Layout } from '../../../components/common/Layout/Layout';
import Img_bird from '../../../assets/img/complete/img_bird.png';
import ImgSp01 from '../../../assets/img/complete/img_sp01.png';
import ImgPc01 from '../../../assets/img/complete/img_pc01.png';

const expireText = window.expireText;

export const Complete: React.FC = () => {
  // 現在のURLパラメータを保持したTOPページのリンクを生成
  // const topPageUrl = useMemo(() => {
  //   const currentParams = new URLSearchParams(window.location.search);
    
  //   // step関連のパラメータを除外
  //   const excludeParams = ['step', 'firstcollectionhandle', 'secondcollectionhandle', 'producthandle'];
  //   excludeParams.forEach(param => currentParams.delete(param));
    
  //   return currentParams.toString() ? `/?${currentParams.toString()}` : '/';
  // }, []);
  return (
    <div className={styles.complete}>
      <h2 className={`${styles.headingLv2} ${styles.isCenter}`}>送信が完了しました</h2>
      <div className={global.operatorWrapper}> 
        <div className={`${global.operatorLabelWrapper}`}>
          <div className={global.operatorLabelInner}>
            <p className={global.operatorLabelTitle}>回答までの日数（目安）</p>
            <div className={global.operatorLabel}>
              {expireText?.trim() && (
                <div dangerouslySetInnerHTML={{ __html: expireText }} />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bgcWhite}>
        <p className={styles.operatorText}>・自動受付メールが届いているかご確認ください。自動受付メールが届いていない場合は、メールアドレスの誤記入などが考えられます。</p>
        <p className={styles.operatorText}>・画像が不鮮明などの理由で、追加の画像が必要な場合は後ほど画像送付をお願いする場合があります。</p>
        <figure className={styles.img}>
          <img src={Img_bird} alt="鳥の画像" width={194} height={163}/>
        </figure>
      </div>
      <div className={styles.contentWrappper}>
        <Layout>
          <div className={styles.titleWrapper}>
            <h2 className={styles.headingLv2}>この後の流れ</h2>
          </div>
          <p className={styles.text}>オンライン修理見積もりのご依頼ありがとうございます。<br /><br />オペレーターがご依頼内容を確認し、お見積もりを作成しご連絡いたします。<br />メールにて修理可否・お見積もりプランをお送り致しますので<br />「店舗持ち込み」もしくは「配送修理」のお好きな方を選択してください</p>
          <div className={styles.flowImg}>
            <picture className={styles.jumbotronImg}>
              <source srcSet={ImgPc01} media="(min-width: 768px)" />
              <img src={ImgSp01} alt="この後の流れのイメージ図" width={344} height={483} />
            </picture>
          </div>
          <div className={styles.buttonWrapper}>
            <a href="/" className={global.primaryButton}>
              オンライン見積もりTOPに戻る
            </a>
          </div>
        </Layout>
      </div>
    </div>
  )
};